import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Message from './Message';

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'gray.100',
        textAlign: 'center',
      }}
    >
      <Message text={'Error 404! Searched webpage was not found'} type={'warning'}/>
      <button
        className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-600 focus:outline-none focus:ring"
        onClick={() => {navigate('/home')}}
        style={{ width: '200px' }}
      >
        Go to Home
      </button>
    </Box>
  );
};

export default NotAuthorized;
